import { isNotNil } from '@flowio/is';
import { RequestPaymentParameters } from '../types';
import { toCamelCaseKeysNested } from './mapKeysNested';

export default function handlePaymentRequestResponse(
  pr: io.flow.v0.models.PaymentRequest,
  requestOptions: RequestPaymentParameters,
): void {
  if (isNotNil(requestOptions.onPaymentMethodCompleted)) {
    const convertedRequest = toCamelCaseKeysNested<
    io.flow.v0.models.PaymentRequest
    >(pr);

    requestOptions.onPaymentMethodCompleted({ request: convertedRequest });
  }
}
